import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import AuthShell from "./AuthShell";
import { GoogleButton } from "./Login";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { inputCls, Field, GoldButton } from "@/components/app/widgets";

export default function Register() {
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const { setUser } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post("/auth/register", form);
      setUser(res.data);
      toast.success("Account created. Check your inbox to verify your email.");
      navigate("/app", { replace: true });
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Create your account"
      sub="Start building partnerships, not spam lists."
      footer={
        <>
          Already have an account?{" "}
          <Link to="/login" data-testid="goto-login-link" className="text-[#D4AF37] hover:brightness-110">
            Sign in
          </Link>
        </>
      }
    >
      <form onSubmit={submit} data-testid="register-form" className="space-y-5">
        <Field label="Full name">
          <input
            type="text" required data-testid="register-name-input"
            value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
            className={inputCls} placeholder="Your name"
          />
        </Field>
        <Field label="Email">
          <input
            type="email" required autoComplete="email" data-testid="register-email-input"
            value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
            className={inputCls} placeholder="you@company.com"
          />
        </Field>
        <Field label="Password" hint="Minimum 8 characters.">
          <input
            type="password" required minLength={8} autoComplete="new-password" data-testid="register-password-input"
            value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
            className={inputCls} placeholder="••••••••"
          />
        </Field>
        <GoldButton type="submit" disabled={loading} data-testid="register-submit-button" className="w-full py-3">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Create Account"}
        </GoldButton>
      </form>
      <div className="my-6 flex items-center gap-4">
        <span className="h-px flex-1 bg-white/10" />
        <span className="text-[10px] uppercase tracking-[0.2em] text-zinc-600">or</span>
        <span className="h-px flex-1 bg-white/10" />
      </div>
      <GoogleButton />
    </AuthShell>
  );
}
